type Uri = { uri: string };

export const inArray = <T extends Uri>(arr: Array<T>, value: T): boolean => {
    return [...arr].filter((item) => item.uri === value.uri).length !== 0;
};

/**
 * If the element exists, removes it, otherwise adds it
 * @param arr array of objects with a uri
 * @param value object with a uri
 * @returns
 */
export const updateArray = <T extends Uri>(arr: Array<T>, value: T): Array<T> => {
    if (!inArray(arr, value)) {
        return [...arr, value];
    } else {
        return [...arr].filter((item) => item.uri !== value.uri);
    }
};

/**
 * Merge and dedupe objects based on their uri
 * @param arr1 array of objects with a uri
 * @param arr2 array of objects with a uri
 * @returns
 */
export const arrayUniqueByUri = <T extends { uri: string }>(arr1: T[], arr2: T[]) => {
    return [...arr1, ...arr2].filter((v, i, a) => a.findIndex((v2) => v2.uri === v.uri) === i);
};

export const arraySwapElements = <T>(arr: T[], index1: number, index2: number) => {
    const output = [...arr];
    if (output[index1] !== undefined && output[index2] !== undefined) {
        output[index1] = output.splice(index2, 1, output[index1])[0];
    }

    return output;
};

export function strArrayToggle(str: string, array: string[]) {
    const idx = array.indexOf(str);
    if (idx !== -1) {
        array.splice(idx, 1);
        return [...array];
    }

    return [...array, str];
}

export function noNull<T>(value: T | null): value is T {
    return value !== null;
}
